// gridVisibilityHelper.js

export const setGridVisibility = (pageKey, columnState) => {
  try {
    localStorage.setItem(`gridColumnVisibility_${pageKey}`, JSON.stringify(columnState));
  } catch (err) {
    console.error('Failed to save grid settings:', err);
  }
};

export const getGridVisibility = (pageKey) => {
  try {
    const data = localStorage.getItem(`gridColumnVisibility_${pageKey}`);
    return data ? JSON.parse(data) : null;
  } catch (err) {
    console.error('Failed to load grid settings:', err);
    return null;
  }
};
